import { DEFINITIONS as PLUGIN_DEFINITIONS } from '@xingternal/content-editor-plugin-paragraph';

import {
  PARAGRAPH_TYPENAME,
  PARAGRAPH_FIELDNAME,
  SERIALIZATION,
  DESERIALIZATION,
} from '../constants';

const INPUT_DEFINITIONS = {
  ...PLUGIN_DEFINITIONS,
  __typename: PARAGRAPH_FIELDNAME,
};

const OUTPUT_DEFINITIONS = {
  ...PLUGIN_DEFINITIONS,
  __typename: PARAGRAPH_TYPENAME,
};

const paragraphSerializer = ({
  createBlock,
  direction,
  extractChildren,
  matchBlock,
  node,
  normalizeInlinesChildren,
  serializeNodes,
}) => {
  if (
    matchBlock({ node, match: INPUT_DEFINITIONS }) ||
    matchBlock({ node, match: OUTPUT_DEFINITIONS })
  ) {
    let children = extractChildren({ node });
    let childrenNodes;

    if (direction === SERIALIZATION) {
      children = normalizeInlinesChildren({ children });
      childrenNodes = serializeNodes(children);

      return createBlock({
        node,
        definitions: INPUT_DEFINITIONS,
        children: childrenNodes,
      });
    }

    if (direction === DESERIALIZATION) {
      children = serializeNodes(children);
      childrenNodes = normalizeInlinesChildren({ children });

      return createBlock({
        node,
        definitions: OUTPUT_DEFINITIONS,
        children: childrenNodes[0],
      });
    }
  }
};

export { paragraphSerializer };
